export default "__VITE_ASSET__CET2MYGX__"